Vue.component("BackgroundText", {
  props: ["config"],
  template: `
      <div class="BackgroundText" :style="[getPosition, getWrapperSize, getCustomStyle]" v-html="config.text"></div>
  `,
  computed: {
      getPosition() {
          return {
              left: this.config.xPosition + 'px', 
              top: this.config.yPosition + 'px'
          }
      },
      getWrapperSize() {
        return {
            width: this.config.width !== '' ? this.config.width : 'auto',
            height: this.config.height !== '' ? this.config.height : 'auto'
        }
      },
      getCustomStyle() {
          return {
              'text-align': this.config.center === true ? 'center' : 'left',
              color: this.config.textColor,
              'font-size': this.config.fontSize,
              opacity: this.config.opacity,
              transform: 'rotate(' + this.config.rotation + 'deg)'
          }
      }
  }
});